import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, useTheme } from '@mui/material/styles';
const Balloon = styled('div')(({ color, background }) => ({
    display: 'inline-block',
    position: 'relative',
    padding: '8px 16px',
    borderRadius: 18,
    fontWeight: 600,
    color: color,
    background: background,
    fontSize: 14,
    textAlign: 'center',
}));
const BalloonTail = styled('div')(({ background }) => ({
    position: 'absolute',
    bottom: -10,
    left: '50%',
    transform: 'translateX(-50%)',
    width: 0,
    height: 0,
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent',
    borderTop: `10px solid ${background}`,
}));
export default function WordBalloon({ text, color, background }) {
    const theme = useTheme();
    const textColor = color || theme.palette.primary.main;
    const backgoundColor = background || theme.palette.primary.light;
    return (_jsxs(Balloon, { color: textColor, background: backgoundColor, children: [text, _jsx(BalloonTail, { background: backgoundColor })] }));
}
